import classNames from 'classnames';
import React, { useContext, useEffect, useState } from 'react';

import { BinotelButton } from '@/widgets/Layout/Binotel/ui/BinotelButton';

import { ButtonSizes, ConditionView } from '@/shared/ui';

import { config } from '@/config/index';

import AuthContext from '@/contexts/Auth/AuthContext';

import { DeafSupport } from '../../DeafSupport';
import { Notifications } from '../../Notifications';
import { OrderServiceLink } from '../../OrderServiceLink';

import './FloatActionButtonsStyles.scss';

export const NO_ORDER_SERVICE_LINK_CLASSNAME = 'fab--no-order-service-link';

export const FloatActionButtons = React.memo(function () {
  const { storedLinks } = useContext(AuthContext);

  const [isNativeKeyboardOpen, setNativeKeyboardOpen] = useState<boolean>(false);

  useEffect(() => {
    const onKeyboardShow = (): void => setNativeKeyboardOpen(true);
    const onKeyboardHide = (): void => setNativeKeyboardOpen(false);

    window.addEventListener('native.keyboardshow', onKeyboardShow);
    window.addEventListener('native.keyboardhide', onKeyboardHide);

    return (): void => {
      window.removeEventListener('native.keyboardshow', onKeyboardShow);
      window.removeEventListener('native.keyboardhide', onKeyboardHide);
    };
  }, []);

  return (
    <ConditionView if={!isNativeKeyboardOpen}>
      <div
        id="fab"
        className={classNames('fab', {
          'fab--no-deaf-support': !storedLinks.videoInstruction.deafSupport,
          [NO_ORDER_SERVICE_LINK_CLASSNAME]: false,
        })}
      >
        <div className="fab__wrapper-inner">
          <div className="fab__list">
            <Notifications className="fab__button fab__button--shrinken" />
            <DeafSupport className="fab__button fab__button--shrinken fab__button--deaf-support" />
            <OrderServiceLink size={ButtonSizes.SM} shorten className="fab__button" />
            <ConditionView if={!!config.binotel.hash}>
              <BinotelButton className="fab__button fab__button--shrinken" />
            </ConditionView>
            {/* styles for "fab__button" are implemented directly in the component */}
          </div>
        </div>
      </div>
    </ConditionView>
  );
});
